<div [formGroup]="form">

    <!-- Account Type Control start -->
    <h4
        id="{{ baseId }}-account-type-subtitle"
        translate
    >Account Type</h4>
    <div class="flex-row-generic">
        <label
            for="{{ baseId }}-account-type"
            class="radio-group-label"
        >
            <mat-radio-group
                name="AccounType"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, accountTypeUidControl, useInsuranceCarrierAccountTypeControl)"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-account-type"
                    value="Payers"
                    [checked]="accountTypeUidControl.disabled"
                    translate
                >
                    Use Payer's Account Type</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-account-type"
                    value="Other"
                    [checked]="!accountTypeUidControl.disabled"
                    translate
                >
                </mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="form-group flex-item-three-columns">
            <ap-findcontrol
                id="{{ baseId }}-account-type-list"
                controlName="accountTypeUid"
                [baseId]="baseId"
                [apFormGroup]="form"
                [(selectedPks)]="selectedAccountTypeControlPks"
                [placeHolder]=""
                [disabled]="accountTypeUidControl.disabled"
                [form]="form"
                [findControlId]="FindControlIdService.ListAccountType"
                [singleSelect]="true"
                findControlDisplayName="Find Account Type"
                [required]="getFindControlValidation('AccountTypeUid')"
                (chipsChange)="onAccountTypeDataPopulate($event)"
                (dirty)="accountTypeUidControl.markAsDirty()"
                [formGroupSubmitted]="isSubmitted"
            >
            </ap-findcontrol>
        </div>
    </div>
    <!-- Account Type Control end -->

    <hr />

    <!-- Fee List Control start -->
    <h4
        id="{{ baseId }}-fee-list-subtitle"
        translate
    >Fee List</h4>
    <div class="flex-row-generic">
        <label
            for="{{ baseId }}-fee-schedule"
            class="radio-group-label"
        >
            <mat-radio-group
                name="FeeSchedule"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, feeScheduleUidControl, null, 'FeeScheduleUid')"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-fee-list"
                    value="Payers"
                    [checked]="checkPayersFee"
                    translate
                >
                    Use Payer's Fee List</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-use-providers-fee-list"
                    value="Providers"
                    [checked]="checkProvidersFee"
                    translate
                >
                    Use Provider’s Fee List</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-fee-list"
                    value="Other"
                    [checked]="!feeScheduleUidControl.disabled"
                    translate
                ></mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="form-group flex-item-three-columns">
            <ap-findcontrol
                id="{{ baseId }}-fee-schedule-list"
                controlName="feeScheduleUid"
                [baseId]="baseId"
                [apFormGroup]="form"
                [placeHolder]=""
                [disabled]="feeScheduleUidControl.disabled"
                [required]="!feeScheduleUidControl.disabled"
                [form]="form"
                [findControlId]="findControlIdService.FeeSchedule"
                [(selectedPks)]="selectedFeeScheduleControlPks"
                [singleSelect]="true"
                findControlDisplayName="Find Fee Schedule"
                (chipsChange)="onFeeScheduleDataPopulate($event)"
                (dirty)="feeScheduleUidControl.markAsDirty()"
                [formGroupSubmitted]="!feeScheduleUidControl.disabled"
            >
            </ap-findcontrol>
        </div>
    </div>
    <!-- Fee List Control end -->

    <hr />

    <!-- Amount Allowed Control start -->
    <h4
        id="{{ baseId }}-amount-allowed-subtitle"
        translate
    >Amount Allowed List</h4>
    <div class="flex-row-generic">
        <label
            for="{{ baseId }}-amount-allowed"
            class="radio-group-label"
        >
            <mat-radio-group
                name="AmountAllowed"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, amountAllowedFeeScheduleUidControl, useCarrierAmountAllowedFeeScheduleControl, 'AmountAllowedFeeScheduleUid')"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-amount-allowed"
                    value="Payers"
                    [checked]="amountAllowedFeeScheduleUidControl.disabled"
                    translate
                >
                    Use Payer's Amount Allowed List</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-amount-allowed"
                    value="Other"
                    [checked]="!amountAllowedFeeScheduleUidControl.disabled"
                    translate
                ></mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="form-group flex-item-three-columns">
            <ap-findcontrol
                id="{{ baseId }}-amount-allowed-list"
                controlName="amountAllowedFeeScheduleUid"
                [baseId]="baseId"
                [apFormGroup]="form"
                [placeHolder]=""
                [disabled]="amountAllowedFeeScheduleUidControl.disabled"
                [form]="form"
                [(selectedPks)]="selectedAmountAllowedListControlPks"
                [findControlId]="findControlIdService.AmountAllowSchedule"
                [singleSelect]="true"
                findControlDisplayName="Find Fee Schedule"
                [required]="!amountAllowedFeeScheduleUidControl.disabled"
                (chipsChange)="onAmountAllowedListDataPopulate($event)"
                (dirty)="amountAllowedFeeScheduleUidControl.markAsDirty()"
                [formGroupSubmitted]="!amountAllowedFeeScheduleUidControl.disabled"
            >
            </ap-findcontrol>
        </div>
    </div>
    <!-- Amount Allowed Control end -->

    <hr />

    <!-- Claim Options start -->
    <h4
        id="{{ baseId }}-claim-options-subtitle"
        translate
    >Claim Options</h4>
    <!-- Paper Claim Format Control start -->
    <div class="flex-row-generic claims-group">
        <label
            for="{{ baseId }}-paper-claim-format"
            class="radio-group-label"
        >Paper Claim Format
            <mat-radio-group
                name="PaperClaimFormat"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, paperClaimFormatUidControl, useCarrierPaperClaimFormatControl, 'PaperClaimFormatUid'); clearPaperClaimFields()"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-paper-claim-format"
                    value="Payers"
                    [checked]="paperClaimFormatUidControl.disabled"
                    translate
                >
                    Use Payer's Paper Claim Format</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-paper-claim-format"
                    value="Other"
                    [checked]="!paperClaimFormatUidControl.disabled"
                    translate
                ></mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="form-group claims-findcontrol flex-item-three-columns">
            <!-- ListClaimFormat -->
            <ap-findcontrol
                id="{{ baseId }}-paper-claim-format-list"
                controlName="paperClaimFormatUid"
                [baseId]="baseId"
                [apFormGroup]="form"
                [placeHolder]=""
                [disabled]="paperClaimFormatUidControl.disabled"
                [form]="form"
                [(selectedPks)]="selectedPaperClaimOptionsControlPks"
                [findControlId]="FindControlIdService.ListClaimFormat"
                [singleSelect]="true"
                findControlDisplayName="Paper Claim Format"
                findControlModalDisplayName="Find Claim Format"
                [required]="!paperClaimFormatUidControl.disabled"
                (chipsChange)="onPaperClaimOptionsControlDataPopulate($event)"
                (dirty)="paperClaimFormatUidControl.markAsDirty()"
                [formGroupSubmitted]="!paperClaimFormatUidControl.disabled"
                [additionalSearchParameters]="paperClaimAdditonalSearchParameters"
            >
            </ap-findcontrol>
        </div>
    </div>
    <!-- Paper Claim Format Control end -->

    <br>

    <!-- Electronic Claim Format Control start -->
    <div class="flex-row-generic claims-group">
        <label
            for="{{ baseId }}-electronic-claim-format"
            class="radio-group-label"
        >Electronic Claim Format
            <mat-radio-group
                name="electronicClaimFormat"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, electronicClaimFormatUidControl, useCarrierElectronicClaimFormatControl, 'ElectronicClaimFormatUid'); clearElectronicClaimFields()"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-electronic-claim-format"
                    value="Payers"
                    [checked]="electronicClaimFormatUidControl.disabled"
                    translate
                >
                    Use Payer's Electronic Claim Format</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-electronic-claim-format"
                    value="Other"
                    [checked]="!electronicClaimFormatUidControl.disabled"
                    translate
                ></mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="form-group claims-findcontrol flex-item-three-columns">
            <ap-findcontrol
                id="{{ baseId }}-electronic-claim-format-list"
                controlName="electronicClaimFormatUid"
                [baseId]="baseId"
                [apFormGroup]="form"
                [placeHolder]=""
                [disabled]="electronicClaimFormatUidControl.disabled"
                [form]="form"
                [(selectedPks)]="selectedElectronicClaimOptionsControlPks"
                [findControlId]="FindControlIdService.ListClaimFormat"
                [singleSelect]="true"
                findControlDisplayName="Electronic Claim Format"
                findControlModalDisplayName="Find Claim Format"
                [required]="!electronicClaimFormatUidControl.disabled"
                (chipsChange)="onElectronicClaimOptionsControlDataPopulate($event)"
                (dirty)="electronicClaimFormatUidControl.markAsDirty()"
                [formGroupSubmitted]="!electronicClaimFormatUidControl.disabled"
                [additionalSearchParameters]="electronicClaimAdditonalSearchParameters"
            >
            </ap-findcontrol>
        </div>
    </div>
    <!-- Electronic Claim Format Control end -->

    <br>

    <!-- Default Claim Format Control start -->
    <div class="flex-row-generic claims-group">
        <label
            for="{{ baseId }}-default-claim-format"
            class="radio-group-label"
        >Default Options
            <mat-radio-group
                name="defaultClaimFormat"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, paperClaimDefaultOptionUidControl, useCarrierPaperClaimDefaultOptionControl, 'PaperClaimDefaultOptionUid'); clearDefaultClaimFields()"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-default-claim-format"
                    value="Payers"
                    [checked]="paperClaimDefaultOptionUidControl.disabled"
                    translate
                >
                    Use Payer's Paper Claim Default Options</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-default-claim-format"
                    value="Other"
                    [checked]="!paperClaimDefaultOptionUidControl.disabled"
                    translate
                ></mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="form-group claims-findcontrol flex-item-three-columns">
            <ap-findcontrol
                id="{{ baseId }}-claim-default-options"
                controlName="paperClaimDefaultOptionUid"
                [baseId]="baseId"
                [apFormGroup]="form"
                [placeHolder]=""
                [disabled]="paperClaimDefaultOptionUidControl.disabled"
                [form]="form"
                [formGroupSubmitted]="!paperClaimDefaultOptionUidControl.disabled"
                findControlDisplayName="Find File Order"
                [(selectedPks)]="selectedClaimDefaultOptionsControlPks"
                [singleSelect]="true"
                [required]="!paperClaimDefaultOptionUidControl.disabled"
                [findControlId]="findControlIdService.ListMisc"
                [requiredSearchParameters]="claimDefaultOptionsRequiredSearchParameters"
                (chipsChange)="onClaimDefaultOptionsControlDataPopulate($event)"
                (dirty)="paperClaimDefaultOptionUidControl.markAsDirty()"
            >
            </ap-findcontrol>
        </div>
    </div>
    <!-- Default Claim Format Control end -->


    <!-- Claim Options end -->


    <hr />

    <!-- Member ID Format Control start -->
    <h4
        id="{{ baseId }}-member-id-format-subtitle"
        translate
    >Member ID Format</h4>
    <div class="flex-row-generic">
        <label
            for="{{ baseId }}-member-id-format"
            class="radio-group-label"
        >
            <mat-radio-group
                name="MemberIDFormat"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, memberIdFormatControl, useCarrierMemberIDFormatControl); clearFormControl(memberIdFormatControl)"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-member-id-format"
                    value="Payers"
                    [checked]="memberIdFormatControl.disabled"
                    translate
                >
                    Use Payer's Member ID Format</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-member-id-format"
                    value="Other"
                    [checked]="!memberIdFormatControl.disabled"
                    translate
                ></mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="form-group flex-item-three-columns">
            <input
                id="{{ baseId }}-member-id-format-input"
                class="form-control"
                [ngClass]="{ error: showErrors(memberIdFormatControl, isSubmitted), 'required': isRequired(memberIdFormatControl) }"
                type="text"
                [maxlength]="fcListValidation.validations.MemberIDFormat.MaxLength"
                formControlName="memberIdFormat"
            />
            <div
                *ngIf="showErrors(memberIdFormatControl, isSubmitted)"
                id="{{ baseId }}-warning-text-member-id-format"
                class="incorrect-input"
                translate
            >
                {{ memberIdFormatControl.errors | fcListValidation : 'MemberIDFormat' : { pattern: 'Only the characters
                (a, A, 9, -, , ?) are valid' } }}
            </div>
        </div>
    </div>
    <!-- Member ID Format Control end -->

    <hr />

    <!-- Group ID Format Control start -->
    <h4
        id="{{ baseId }}-group-id-format-subtitle"
        translate
    >Group ID Format</h4>
    <div class="flex-row-generic">
        <label
            for="{{ baseId }}-group-id-format"
            class="radio-group-label"
        >
            <mat-radio-group
                name="groupIdFormat"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, groupIdFormatControl, useCarrierGroupIDFormatControl); clearFormControl(groupIdFormatControl)"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-group-id-format"
                    value="Payers"
                    [checked]="groupIdFormatControl.disabled"
                    translate
                >
                    Use Payer's Group ID Format</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-group-id-format"
                    value="Other"
                    [checked]="!groupIdFormatControl.disabled"
                    translate
                ></mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="form-group flex-item-three-columns">
            <input
                id="{{ baseId }}-group-id-format-input"
                class="form-control"
                [ngClass]="{ error: showErrors(groupIdFormatControl, isSubmitted), 'required': isRequired(groupIdFormatControl) }"
                type="text"
                [maxlength]="fcListValidation.validations.GroupIDFormat.MaxLength"
                formControlName="groupIdFormat"
            />
            <div
                *ngIf="showErrors(groupIdFormatControl, isSubmitted)"
                id="{{ baseId }}-warning-text-group-id-format"
                class="incorrect-input"
                translate
            >
                {{ groupIdFormatControl.errors | fcListValidation : 'GroupIDFormat' : { pattern: 'Only the characters
                (a, A, 9, -, , ?) are valid' } }}
            </div>
        </div>
    </div>
    <!-- Group ID Format Control end -->

    <hr />

    <!-- Reimbursement Rule Type Control start -->
    <h4
        id="{{ baseId }}-reimbursement-rule-subtitle"
        translate
    >Reimbursement Rule</h4>
    <div class="flex-row-generic">
        <label
            for="{{ baseId }}-reimbursement-rule"
            class="radio-group-label"
        >
            <mat-radio-group
                name="Reimbursement"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, reimbursementRuleUidControl, null, 'ReimbursementRuleUid')"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-reimbursement-rule"
                    value="Payers"
                    [checked]="reimbursementRuleUidControl.disabled"
                    translate
                >
                    Use Payer's Reimbursement Rule</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-reimbursement-rule"
                    value="Other"
                    [checked]="!reimbursementRuleUidControl.disabled"
                    translate
                >
                </mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="form-group flex-item-three-columns">
            <ap-findcontrol
                id="{{ baseId }}-reimbursement-rule-list"
                controlName="reimbursementRuleUid"
                [baseId]="baseId"
                [apFormGroup]="form"
                [placeHolder]=""
                [disabled]="reimbursementRuleUidControl.disabled"
                [(selectedPks)]="selectedReimbursementRuleControlPks"
                [findControlId]="findControlIdService.ListReimbursementRule"
                [singleSelect]="true"
                findControlDisplayName="Find Reimbursement Rule Set"
                [required]="!reimbursementRuleUidControl.disabled"
                (chipsChange)="onReimbursementRuleDataPopulate($event)"
                (dirty)="reimbursementRuleUidControl.markAsDirty()"
                [formGroupSubmitted]="!reimbursementRuleUidControl.disabled"
            >
            </ap-findcontrol>
        </div>
    </div>
    <!-- Reimbursement Rule Type Control end -->

    <hr />

    <!-- Auto Writeoff Adj Type Control start -->
    <h4
        id="{{ baseId }}-auto-writeoff-adj-type-subtitle"
        translate
    >Auto-writeoff Adjustment Type</h4>
    <div class="flex-row-generic">
        <label
            for="{{ baseId }}-auto-writeoff-adj-type"
            class="radio-group-label"
        >
            <mat-radio-group
                name="AutoWriteoffAdjustmentType"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, autoWriteoffCreditTypeUidControl, useCarrierAutoWriteoffCreditTypeControl, 'AutoWriteoffCreditTypeUid')"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-auto-writeoff-adj-type"
                    value="Payers"
                    [checked]="autoWriteoffCreditTypeUidControl.disabled"
                    translate
                >
                    Use Payer's Auto-writeoff Adj Type</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-auto-writeoff-adj-type"
                    value="Other"
                    [checked]="!autoWriteoffCreditTypeUidControl.disabled"
                    translate
                >
                </mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="form-group flex-item-three-columns">
            <ap-findcontrol
                id="{{ baseId }}-auto-writeoff-adj-type-list"
                controlName="autoWriteoffCreditTypeUid"
                findControlDisplayName="Find Credit Types"
                [baseId]="baseId"
                [apFormGroup]="form"
                [placeHolder]=""
                [disabled]="autoWriteoffCreditTypeUidControl.disabled"
                [form]="form"
                [(selectedPks)]="selectedAutoWriteoffAdjTypeControlPks"
                [findControlId]="findControlIdService.ListCreditType"
                [singleSelect]="true"
                [required]="!autoWriteoffCreditTypeUidControl.disabled"
                [formGroupSubmitted]="!autoWriteoffCreditTypeUidControl.disabled"
                (chipsChange)="onAutoWriteoffAdjTypeDataPopulate($event)"
                (dirty)="autoWriteoffCreditTypeUidControl.markAsDirty()"
            >
            </ap-findcontrol>
        </div>
    </div>
    <!-- Auto Writeoff Adj Type Control end -->

    <hr />

    <!-- Referral Required Control start -->
    <h4
        id="{{ baseId }}-referral-required-subtitle"
        translate
    >Referral Required</h4>
    <div class="flex-row-generic">
        <label
            for="{{ baseId }}-referral-required"
            class="radio-group-label"
        >
            <mat-radio-group
                name="ReferralRequired"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, referralRequiredControl, userCarrierReferralRequiredControl)"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-referral-required"
                    value="Payers"
                    [checked]="referralRequiredControl.disabled"
                    translate
                >
                    Use Payer's Referral Required Setting</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-referral-required"
                    value="Other"
                    [checked]="!referralRequiredControl.disabled"
                    translate
                >
                </mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="checkbox-group">
            <mat-checkbox
                id="{{ baseId }}-referral-required-checkbox"
                formControlName="referralRequired"
                translate
            >
                Requires a Referral </mat-checkbox>
        </div>
    </div>
    <!-- Referral Required end -->

    <hr />

    <!-- Network Control start -->
    <h4
        id="{{ baseId }}-network-subtitle"
        translate
    >Network</h4>
    <div class="flex-row-generic">
        <label
            for="{{ baseId }}-network"
            class="radio-group-label"
        >
            <mat-radio-group
                name="Network"
                class="radio-group space-radio-buttons"
                (change)="onRadioChange($event, noNetworkControl, useCarrierNoNetworkControl)"
            >
                <mat-radio-button
                    id="{{ baseId }}-use-payers-network"
                    value="Payers"
                    [checked]="noNetworkControl.disabled"
                    translate
                >
                    Use Payer's No Network</mat-radio-button>
                <mat-radio-button
                    id="{{ baseId }}-choose-network"
                    value="Other"
                    [checked]="!noNetworkControl.disabled"
                    translate
                >
                </mat-radio-button>
            </mat-radio-group>
        </label>
        <div class="network-group">
            <div class="checkbox-group">
                <mat-checkbox
                    id="{{ baseId }}-network-checkbox"
                    formControlName="noNetwork"
                    translate
                > No Network
                </mat-checkbox>
            </div>
            <button
                class="btn btn-light btn-large"
                type="button"
                [disabled]="isNewMode"
                (click)="onMapNetworkClick()"
            >Map Network</button>
        </div>
    </div>
    <!-- Network Control end -->
</div>
